import React from 'react'
import urls from '@/utils/urls/urls'
import ProductsLatestContainer from './ProductsLatestContainer'
import Link from 'next/link'

const ProductsSection = async () => {
    // const res = await fetch(urls?.brand, {
    //     cache: "no-cache"
    // })
    // const data = await res.json()
    // const brands = await Array.isArray(data?.data) ? data?.data : [];
    // cl("Products", products);

    return (
        <div className="portfolio-area py-120">
            <div
                className="pa-bg"
                style={{ backgroundImage: "url(../assets/img/portfolio/bg.jpg)" }}
            />
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 mx-auto">
                        <div className="site-heading text-center">
                            <span className="site-title-tagline">
                                <i className="far fa-solar-panel" /> Our Products
                            </span>
                            <h2 className="site-title text-white">
                                Let's check our latest Products
                            </h2>
                        </div>
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-lg-12 d-flex justify-content-center gap-4 align-items-center mb-4">
                        {
                            brands.map((brand: any) => (
                                <a key={brand?.id} href={brand?.product_link} target='_blank's>
                                    <button className="theme-btn nav-theme-btn">
                                        {brand?.name}
                                    </button>
                                </a>
                            ))
                        }
                    </div>
                </div> */}
                <div className="row popup-gallery">
                    {/* <div className="portfolio-slider owl-carousel grid"> */}
                    <ProductsLatestContainer />
                </div>
            </div>
        </div>
    )
}

export default ProductsSection
